class MainSearch extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      resultsGrid: '[js-search-results-grid]',
      searchForm: '[js-search-form]',
      searchInput: '#Search-In-Template',
      searchTerms: '[js-search-terms]',
      noResults: '[js-search-no-results]',
      resultsContainer: '[js-search-results-container]',
      filters: '[js-searchspring-filters]',
      sort: '[js-searchspring-sort]',
      pagination: '[js-search-pagination]',
    }
  }

  connectedCallback() {
    this.collectionMode = this.dataset.collectionMode || 'regular';
    this.collectionHandle = this.dataset.collectionHandle;
    this.resultsGrid = this.querySelector(this._selectors.resultsGrid);
    this.form = this.querySelector(this._selectors.searchForm);
    this.input = this.querySelector(this._selectors.searchInput);
    this.noResults = this.querySelector(this._selectors.noResults);
    this.resultsContainer = this.querySelector(this._selectors.resultsContainer);
    this.sort = this.querySelector(this._selectors.sort);
    this.pagination = this.querySelector(this._selectors.pagination);
    this.searchTerms = this.querySelector(this._selectors.searchTerms);
    this.filtersContainer = document.querySelector(this._selectors.filters);
    this.sortContainer = document.querySelector(this._selectors.sort);

    this.siteId = 'zcq50k';
    this.query = new URLSearchParams(window.location.search).get("query");
    this.input.value = this.query;

    this.storeData = {
      filters: '',
      sort: '',
      currentPage: 1,
      gridView: '',
      view: this.dataset.collectionMode === 'expanded' ? 'expanded' : '',
    }

    this._restoreFiltersFromURL();

    this.openedFiltersAccordionTabs = [];

    this.iconPlus = `<svg class="icon icon-plus" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <title>Plus</title>
                      <path d="M7 0V14" stroke="currentColor" stroke-width="1.5"/>
                      <path d="M14 7L-7.15256e-07 7" stroke="currentColor" stroke-width="1.5"/>
                    </svg>`;
    this.iconMinus = `<svg class="icon icon-minus" viewBox="0 0 13 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>Minus</title>
                        <path d="M14 1L-7.15256e-07 0.999999" stroke="currentColor" stroke-width="1.5"/>
                      </svg>`;
    this.iconHeart = `<svg class="icon icon--full-color icon-heart" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>Favorite</title>
                        <path d="M4.45067 13.9082L11.4033 20.4395C11.6428 20.6644 11.7625 20.7769 11.9037 20.8046C11.9673 20.8171 12.0327 20.8171 12.0963 20.8046C12.2375 20.7769 12.3572 20.6644 12.5967 20.4395L19.5493 13.9082C21.5055 12.0706 21.743 9.0466 20.0978 6.92607L19.7885 6.52734C17.8203 3.99058 13.8696 4.41601 12.4867 7.31365C12.2913 7.72296 11.7087 7.72296 11.5133 7.31365C10.1304 4.41601 6.17972 3.99058 4.21154 6.52735L3.90219 6.92607C2.25695 9.0466 2.4945 12.0706 4.45067 13.9082Z" stroke="currentColor" stroke-width="1.5"/>
                      </svg>`;
    this.iconCarat = `<svg class="icon  icon--full-color icon-carat" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>Carat</title>
                        <path d="M1 9.12402L6.85117 4.24805L12.7023 9.12402" stroke="currentColor"/>
                      </svg>`;

    this.triggered = false;
    this._retainHistory();
    this._clearFilterSort();
    this._setListeners();

    setTimeout(() => {
      this._updateGridLayoutLinks();
      if (this.storeData.filters || this.storeData.sort) {
        this._fetchSearchAPI();
      }
    }, 100);
  }

  _setListeners() {
    window.addEventListener('scrollend', this._handleScrollEnd);
    window.addEventListener('scroll', this._handleScroll);
    this.form.addEventListener("submit", this._onSubmit);

    this._observeGridChanges();
  }

  _observeGridChanges() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-d-cols') {
          const newGridValue = document.body.getAttribute('data-d-cols');

          if (newGridValue === 'gallery') {
            this.dataset.collectionMode = 'expanded';
            this.storeData.view = 'expanded';
          } else {
            this.dataset.collectionMode = 'regular';
            this.storeData.view = '';
          }

          setTimeout(() => {
            this._fetchSearchAPI();
          }, 100);
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-d-cols']
    });
  }

  _updateGridLayoutLinks() {
    const currentParams = new URLSearchParams();

    if (this.query) {
      currentParams.set('query', this.query);
    }

    if (this.storeData.filters) {
      const filterString = this.storeData.filters;
      const filterMatches = filterString.match(/&filter\.([^=]+)=([^&]+)/g);
      if (filterMatches) {
        filterMatches.forEach(match => {
          const [, key, value] = match.match(/&filter\.([^=]+)=(.+)/);
          currentParams.set(`filter.${key}`, decodeURIComponent(value));
        });
      }
    }

    if (this.storeData.sort) {
      const sortMatch = this.storeData.sort.match(/&sort\.([^=]+)=(asc|desc)/);
      if (sortMatch) {
        const [, field, direction] = sortMatch;
        const sortMapping = {
          'ss_price': 'price',
          'title': 'title',
          'ss_days_since_published': 'created'
        };
        const shopifyField = sortMapping[field] || field;
        const shopifyDirection = direction === 'asc' ? 'ascending' : 'descending';
        currentParams.set('sort_by', `${shopifyField}-${shopifyDirection}`);
      }
    }

    if (this.storeData.currentPage && this.storeData.currentPage > 1) {
      currentParams.set('page', this.storeData.currentPage);
    }

    const baseUrl = window.location.pathname;

    const expandedViewLink = document.querySelector('.layout-sort__column-count-trigger--gallery');
    if (expandedViewLink && expandedViewLink.tagName.toLowerCase() === 'a') {
      const expandedParams = new URLSearchParams(currentParams);
      expandedParams.set('view', 'expanded');
      const expandedUrl = expandedParams.toString() ? `${baseUrl}?${expandedParams.toString()}` : `${baseUrl}?view=expanded`;
      expandedViewLink.href = expandedUrl;
    }

    const regularViewLink = document.querySelector('.layout-sort__column-count-trigger--4, .layout-sort__column-count-trigger--3');
    if (regularViewLink && regularViewLink.tagName.toLowerCase() === 'a') {
      const regularParams = new URLSearchParams(currentParams);
      regularParams.delete('view');
      const regularUrl = regularParams.toString() ? `${baseUrl}?${regularParams.toString()}` : baseUrl;
      regularViewLink.href = regularUrl;
    }

    const twoColLink = document.querySelector('.layout-sort__column-count-trigger--2');
    if (twoColLink && twoColLink.tagName.toLowerCase() === 'a') {
      const twoColParams = new URLSearchParams(currentParams);
      twoColParams.delete('view');
      twoColParams.set('cols', '2');
      const twoColUrl = twoColParams.toString() ? `${baseUrl}?${twoColParams.toString()}` : `${baseUrl}?cols=2`;
      twoColLink.href = twoColUrl;
    }
  }

  _restoreFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    let searchSpringFilters = '';
    let searchSpringSort = '';

    for (const [key, value] of urlParams) {
      if (key.startsWith('filter.')) {
        const filterKey = key.substring(7);
        searchSpringFilters += `&filter.${filterKey}=${encodeURIComponent(value)}`;
      } else if (key === 'sort_by') {
        const sortMapping = {
          'price-ascending': '&sort.ss_price=asc',
          'price-descending': '&sort.ss_price=desc',
          'title-ascending': '&sort.title=asc',
          'title-descending': '&sort.title=desc',
          'created-descending': '&sort.ss_days_since_published=asc',
          'created-ascending': '&sort.ss_days_since_published=desc'
        };
        if (sortMapping[value]) {
          searchSpringSort = sortMapping[value];
        }
      } else if (key === 'page') {
        this.storeData.currentPage = parseInt(value) || 1;
      }
    }

    if (searchSpringFilters) {
      this.storeData.filters = searchSpringFilters;
    }
    if (searchSpringSort) {
      this.storeData.sort = searchSpringSort;
    }
  }

  _retainHistory() {
    if (!history.state) {
      return;
    }

    if (history.state.filters) {
      this.storeData.filters = history.state.filters;
    }

    if (history.state.sort) {
      this.storeData.sort = history.state.sort;
    }

    if (history.state.currentPage) {
      this.storeData.currentPage = history.state.currentPage;
    }
  }

  _changeHistory(url = false, clear = false) {
    let state = {};
    if (history.state) {
      state = history.state;
    }

    state.filters = this.storeData.filters;
    state.sort = this.storeData.sort;
    state.currentPage = this.storeData.currentPage;
    state.gridView = this.storeData.gridView;
    state.view = this.storeData.view;

    if (url) {
      const urlParams = new URLSearchParams();

      if (this.query) {
        urlParams.set('query', this.query);
      }

      if (this.storeData.filters) {
        const filterString = this.storeData.filters;
        const filterMatches = filterString.match(/&filter\.([^=]+)=([^&]+)/g);
        if (filterMatches) {
          filterMatches.forEach(match => {
            const [, key, value] = match.match(/&filter\.([^=]+)=(.+)/);
            urlParams.set(`filter.${key}`, decodeURIComponent(value));
          });
        }
      }

      if (this.storeData.sort) {
        const sortMatch = this.storeData.sort.match(/&sort\.([^=]+)=(asc|desc)/);
        if (sortMatch) {
          const [, field, direction] = sortMatch;
          const sortMapping = {
            'ss_price': 'price',
            'title': 'title',
            'ss_days_since_published': 'created'
          };
          const shopifyField = sortMapping[field] || field;
          const shopifyDirection = direction === 'asc' ? 'ascending' : 'descending';
          urlParams.set('sort_by', `${shopifyField}-${shopifyDirection}`);
        }
      }

      if (this.storeData.currentPage && this.storeData.currentPage > 1) {
        urlParams.set('page', this.storeData.currentPage);
      }

      if (this.storeData.view) {
        urlParams.set('view', this.storeData.view);
      }

      if (clear) {
        urlParams.forEach((value, key) => {
          if (key !== 'query' && key !== 'page' && key !== 'view') {
            urlParams.delete(key);
          }
        });
      }

      const paramString = urlParams.toString();
      const newPath = paramString ? `${window.location.pathname}?${paramString}` : window.location.pathname;

      history.pushState(state, '', newPath);
      this._updateGridLayoutLinks();
    } else {
      history.pushState(state, '');
    }
  }

  _paginationComponent(pagination) {
    if (pagination.nextPage != 0) {
      return  `<button class="template-search__view-more-button btn block mx-auto mt-40 desktop:mt-56 max-w-max" js-search-view-more-btn>
                See More (${pagination.totalResults - pagination.end})
              </button>`
    } else {
      return '';
    }
  }

  _loadNextPage() {
    const viewMoreBtn = this.pagination.querySelector('[js-search-view-more-btn]');
    if (viewMoreBtn) {
      viewMoreBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.storeData.currentPage++;
        this._changeHistory(true, false);
        this._fetchSearchAPI(true);
      });
    }
  }

  getCookie = (name) => {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts && parts.length === 2) {
			return parts.pop().split(';').shift();
		} else {
			return ''
		}
	};

  callSearchSpringPreflight = async () => {
		const personalizedParams = this.getPersonalizationParams();
		const url = `https://${this.siteId}.a.searchspring.io/api/personalization/preflightCache?shopper=${personalizedParams.shopper}&cart=${personalizedParams.cart}&lastViewed=${personalizedParams.lastViewed}`;
		const options = {method: 'GET'};
		const response = await fetch(url, options)
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
	}

	getTrackingParams = () => {
		return {
			userId: this.getCookie('ssUserId'),
			sessionId: this.getCookie('ssSessionIdNamespace'),
			pageLoadId: this.getCookie('pageLoadId'),
			domain: window.location.href
		};
	};

	getPersonalizationParams = () => {
		return {
			shopper: this.getCookie('ssUserId'),
			cart: this.getCookie('shopify_cart_products'),
			lastViewed: this.getCookie('shopify_last_viewed')
		};
	};

  async _renderProductCards(res, productCardsMarkup, nextPage) {
    if (res.merchandising.redirect !== '') {
      window.location.href = res.merchandising.redirect;
      return false;
    }

    this.triggered = true;
    if (res.pagination.totalResults > 0) {
      if (!nextPage) {
        this.resultsGrid.innerHTML = '';
      }

      this.noResults.classList.add('hidden');
      this.resultsContainer.classList.remove('hidden');
      this.resultsGrid.insertAdjacentHTML("beforeend", productCardsMarkup);

      const cardElements = this.resultsGrid.querySelectorAll('[data-intellisuggest-data]');
      cardElements.forEach(function (element) {
        element.addEventListener('mousedown', function () {
          IntelliSuggest.clickItem(this, {
            siteId: "zcq50k",
            intellisuggestData: element.dataset.intellisuggestData,
            intellisuggestSignature: element.dataset.intellisuggestSignature
          });
        });
      });

      const paginationMarkup = this._paginationComponent(res.pagination);
      this.pagination.innerHTML = paginationMarkup;

      const filtersMarkup = this._filtersComponent(res);

      if(window.rfd && window.rfd.collectionPageMobileCarouselReinit && this.collectionMode !== 'expanded') {
        window.rfd.collectionPageMobileCarouselReinit();
      }

      if (this.collectionHandle) {
        if (!!this.filtersContainer) {
          this.filtersContainer.innerHTML = filtersMarkup;
          this._updateFiltersAccordion();
          this._handleFiltersChange();

          const sortMarkup = this._sortComponent(res.sorting);
          this.sortContainer.innerHTML = sortMarkup;
          this._handleSortChange();
        }
      }
      this.triggered = false;
      document.body.classList.add('collection-loaded');
    } else {
      this.noResults.querySelector('[js-search-query]').textContent = `"${this.query}"`;
      this.noResults.classList.remove('hidden');
      this.resultsContainer.classList.add('hidden');
    }
  }

  async _fetchSearchAPI(nextPage = false) {
    const isExpandedView = this.dataset.collectionMode === 'expanded'
    const productsPerPage = isExpandedView ? 54: 36;
    const productsNum = parseInt(this.storeData.currentPage) * productsPerPage;

    const personalizedParams = this.getPersonalizationParams();
    const trackingParams = this.getTrackingParams();

    const baseParams = new URLSearchParams({
      siteId: this.siteId,
      ...trackingParams,
      ...personalizedParams,
    }).toString();

    const fetchUrl = `https://${this.siteId}.a.searchspring.io/api/search/search.json?${baseParams}&resultsFormat=json${this.query ? `&q=${this.query}`: ''}&redirectResponse=minimal&page=${nextPage ? this.storeData.currentPage : 1}&resultsPerPage=${nextPage ? productsPerPage : productsNum}${this.storeData.filters}${this.collectionHandle ? `&bgfilter.collection_handle=${this.collectionHandle}` : ''}&bgfilter.ss_is_published=1&is_published=yes${this.storeData.sort}`;
    const options = { method: 'GET', headers: { accept: 'application/json' } };

    // Call SearchSpring Preflight
    await this.callSearchSpringPreflight().then().catch((error) => {
      console.error('Preflight Cache Error:', error);
    });

    const searchResponse = await Promise.all([
      fetch(fetchUrl, options),
    ]).then(responses => {
      return Promise.all(responses.map(function (response) {
        return response.json();
      }));
    }).then(async response => {
      let productCardsMarkup = '<ul class="template-search__results-grid w-full list-none grid grid-cols-2 gap-x-16 desktop:grid-cols-4 gap-y-24 desktop:gap-y-40 pl-0" role="list" js-search-results-grid>';

      if(!isExpandedView) {
        if (response[0].results && response[0].results.length > 0) {
          let productCardArray = new Array;
          var productCardFetches = [];
          for (const product of response[0].results) {
            productCardFetches.push(
              fetch(`/products/${product.handle}/?view=product-card`)
                .then(response => response.text())
                .then((text) => {
                  const html = text;
                  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
                  if (parsedHTML.querySelector('[js-product-card-copy]') != null) {
                    parsedHTML.querySelector('.products__listing.js-block').setAttribute('data-index', response[0].results.indexOf(product) + 1);
                    parsedHTML.querySelector('.products__listing.js-block').setAttribute('data-intellisuggest-data', product.intellisuggestData);
                    parsedHTML.querySelector('.products__listing.js-block').setAttribute('data-intellisuggest-signature', product.intellisuggestSignature);
                    const productCardCopy = parsedHTML.querySelector('[js-product-card-copy]').innerHTML;

                    productCardArray.push(productCardCopy);
                  }
                })
            )
          }

          await Promise.all(productCardFetches).then(function() {
            for (const productCard of productCardArray) {
              const productCardContent = new DOMParser().parseFromString(productCard, 'text/html');
              const productCardIndex = parseInt(productCardContent.querySelector('.products__listing.js-block').getAttribute('data-index')) || 0;

              if (window.innerWidth < 1240) {
                const hoverImage = productCardContent.querySelector('.js-product-image-hover');

                if (hoverImage) {
                  hoverImage.remove();
                }

                if (productCardIndex < 4) {
                  productCardContent.querySelectorAll('[loading]').forEach((img) => {
                    img.removeAttribute('loading');
                  });
                }
              } else {
                if (productCardIndex < 8) {
                  productCardContent.querySelectorAll('[data-x]').forEach((block) => {
                    block.removeAttribute('data-x');
                  });
                  productCardContent.querySelectorAll('[loading]').forEach((img) => {
                    img.removeAttribute('loading');
                  });
                }
              }

              const productCardWrapper = `
                <li
                  class="template-search__grid-item"
                  style="--order-index: ${productCardContent.querySelector('.products__listing.js-block')?.getAttribute('data-index') || 0};"
                >
                  ${productCardContent.querySelector('.products__listing.js-block')?.outerHTML || ''}
                </li>
              `;
              productCardsMarkup = `${productCardsMarkup}${productCardWrapper}`
            }
          });
        }
      } else {
        response[0].results.map(result => {
          const altImage = result.images && result.images[1]
          const productVideo = false // result.mfield_custom_product_card_video || TODO: Searcspring API does not return video URL, only the UID of the video
          const showProductVideoAsPrimaryAsset = result.mfield_custom_show_product_card_video_as_primary_asset

          productCardsMarkup += `
          <li
            class="template-search__grid-item"
            data-intellisuggest-data="${result.intellisuggestData}"
            data-intellisuggest-signature="${result.intellisuggestSignature}"
          >
            <a href="${result.url}" aria-label="View ${result.name}">
              ${showProductVideoAsPrimaryAsset && productVideo ?
                `
                  <video
                    src="${productVideo}"
                    alt="${result.name}"
                    loop
                    autoplay
                    muted
                    playsinline
                  >
                  </video>
                ` :
                `
                  <img
                    src="${result.imageUrl}"
                    alt="${result.name}"
                  />
                `
              }
            </a>
          </li>
        `;

        })

      }

      productCardsMarkup = `${productCardsMarkup}</ul>`;

      if (!!response[0].pagination.totalResults) {
        this.searchTerms.innerHTML = `
          <div class="heading__inner">
            <h1 class="h4 heading__inner-search">${response[0].pagination.totalResults} search results for "${this.query}"</h1>
          </div>
        `;
      }

      return [response[0], productCardsMarkup];
    }).catch(function (error) {
      console.log(error);
    });

    if (searchResponse[1].length > 0) {
      this._renderProductCards(searchResponse[0], searchResponse[1], nextPage);
      this._loadNextPage();
    }
  }

  _filtersComponent(res) {
    const facets = res.facets;
    let filtersMarkup = '';
    facets.forEach((facet, index) => {
      const activeValuesPerFacet = facet.values.filter(value => value.active);
      const numRows = Math.ceil(facet.values.length / 2.0);
      let facetValues= '';

      if (facet.field === 'ss_nested_filters_hierarchy') {
        facetValues = this._renderNestedFilters(facet.values, facet.field);
      } else {
        facet.values.forEach((value, i) => {
          const valueId = `FilterSort-${facet.field}-${i}`;
          facetValues = `
            ${facetValues}
            <li class="filter-sort__value">
              <div class="filter-value">
                <input type="checkbox"
                  name="${value.label}"
                  value="${value.type == 'range' ? `&filter.${facet.field}.low=${value.low}&filter.${facet.field}.high=${value.high}` : `&filter.${facet.field}=${value.value}`}"
                  id="${valueId}"
                  class="filter-value__input"
                  ${value.active ? 'checked' : ''}
                  ${value.count == 0 && value.active == false ? 'disabled' : ''}
                  js-searchspring-filter-input
                >
                <label for="${valueId}" class="filter-value__label ${value.count == 0 && value.active == false ? 'disabled opacity-30' : ''}">
                  <span class="break-words">${facet.multiple == 'single' ? `${value.label == 'Yes' ? 'YES' : 'NO' }` : `${value.label}`}</span>
                  <span class="filter-value__label-count font-coolvetica font-400 hidden"> (${value.count})</span>
                </label>
              </div>
            </li>
          `;
        });
      }
      filtersMarkup = `
        ${filtersMarkup}
        <div class="filter-sort accordion-item border-b border-black ${facet.label == 'Collection' ? 'hidden' : ''}" data-index="${index}" js-accordion-item>
          <button class="filter-sort__label accordion-header" aria-expanded="false" aria-controls="${facet.field}-master-filter" type="button" js-accordion-header>
            <div class="label__wrapper">
              <sapn class="filter-sort__label-text flex-1">${facet.label}</sapn>
            </div>
            <span class="filter-sort__label-icon">${this.iconPlus}${this.iconMinus}</span>
          </button>
          <div id="${facet.field}-master-filter" class="filter-sort__values-container accordion-content" aria-hidden="true" js-accordion-content>
            <ul class="filter-sort__values pb-16 pl-40 ${facet.field === 'ss_nested_filters_hierarchy' ? 'nested-filters-container' : 'grid grid-cols-2 gap-4'}" role="list" style="--num-rows: ${numRows};">${facetValues}</ul>
          </div>
        </div>
      `;
    });

    return `
      <form class="searchspring-filters__form">
        <div class="filter-sort__filters-container">
          <s-accordion class="block border-t border-black" data-manual-collapse="false" js-accordion>${filtersMarkup}</s-accordion>
        </div>
        <div class="filter-sort__footer">
          <button class="btn btn--clear filters__clear-btn js-clear-filters-btn">
            Clear Filters
          </button>
        </div>
      </form>
    `;

  }

  _renderNestedFilters(values, fieldName) {
    let html = '';

    const sortedValues = values.slice().sort((a, b) => {
      const aPath = a.label.split('>');
      const bPath = b.label.split('>');

      for (let i = 0; i < Math.max(aPath.length, bPath.length); i++) {
        const aSegment = aPath[i] || '';
        const bSegment = bPath[i] || '';

        if (aSegment !== bSegment) {
          return aSegment.localeCompare(bSegment);
        }
      }

      return aPath.length - bPath.length;
    });

    sortedValues.forEach((value, index) => {
      const parts = value.label.split('>');
      const depth = parts.length - 1;
      const displayLabel = parts[parts.length - 1].trim();
      const valueId = `FilterSort-${fieldName}-${index}`;
      const isChecked = value.active;
      const isDisabled = value.count == 0 && !isChecked;
      const leftPadding = depth * 20;

      const filterValue = value.type == 'range' ?
        `&filter.${fieldName}.low=${value.low}&filter.${fieldName}.high=${value.high}` :
        `&filter.${fieldName}=${value.value}`;

      html += `
        <li class="filter-sort__value" data-level="${depth}">
          <div class="filter-value" style="padding-left: ${leftPadding}px;">
            <input type="checkbox"
              name="${value.label}"
              value="${filterValue}"
              id="${valueId}"
              class="filter-value__input"
              ${isChecked ? 'checked' : ''}
              ${isDisabled ? 'disabled' : ''}
              js-searchspring-filter-input
            >
            <label for="${valueId}" class="filter-value__label ${isDisabled ? 'disabled opacity-30' : ''}">
              <span class="break-words">${displayLabel}</span>
              <span class="filter-value__label-count font-coolvetica font-400 hidden"> (${value.count})</span>
            </label>
          </div>
        </li>
      `;
    });

    return html;
  }

  _clearFilterSort() {
    this.storeData.filterSort = '';
    this.storeData.currentPage = 1;
    this._changeHistory(true, true);
    this._fetchSearchAPI();
  }

  _handleSortChange() {
    this.sortContainer.querySelectorAll('a').forEach(sortOption => {
      sortOption.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.storeData.sort = evt.currentTarget.dataset.value;
        this._changeHistory(true, false);
        this._fetchSearchAPI();
      })
    });
  }

  _handleFiltersChange() {
    const filterForm = this.filtersContainer.querySelector('form');

    filterForm.addEventListener('input', (evt) => {
      evt.preventDefault();
      this.openedFiltersAccordionTabs = filterForm.querySelectorAll('[js-accordion-header][aria-expanded="true"]');
      const checkedInputs = filterForm.querySelectorAll('[js-searchspring-filter-input]:checked');
      let activeValues = '';
      checkedInputs.forEach((input) => {
        activeValues = `${activeValues}${input.value}`;
      });
      this.storeData.filters = activeValues;
      this._changeHistory(true, false);
      this._fetchSearchAPI();
    });
  }

  _updateFiltersAccordion() {
    this.openedFiltersAccordionTabs.forEach((tab) => {
      const openedTab = this.filtersContainer.querySelector(`[js-accordion-header][aria-controls=${tab.getAttribute('aria-controls')}]`);
      if (openedTab) {
        openedTab.setAttribute('aria-expanded', true);
        openedTab.nextElementSibling.setAttribute('aria-hidden', false);
      }
    });
  }

  _sortComponent(sort) {
    return `
      <li class="filter-group__item" data-href="?sort_by=created-descending">
        <a
          data-href="?sort_by=created-descending"
          data-value="&amp;sort.ss_days_since_published=asc"
          data-filter-sort
          data-ajax-ctrl
        >
        Newest
        </a>
      </li>

      <li class="filter-group__item" data-href="?sort_by=price-ascending">
        <a
          data-href="?sort_by=price-ascending"
          data-value="&amp;sort.ss_price=asc"
          data-filter-sort
          data-ajax-ctrl
        >
        Price (Lowest)
        </a>
      </li>
      <li class="filter-group__item" data-href="?sort_by=price-descending">
        <a
          data-href="?sort_by=price-descending"
          data-value="&amp;sort.ss_price=desc"
          data-filter-sort
          data-ajax-ctrl
        >
        Price (Highest)
        </a>
      </li>
      <li class="filter-group__item" data-href="?sort_by=title-ascending">
        <a
          data-href="?sort_by=title-ascending"
          data-value="&amp;sort.title=asc"
          data-filter-sort
          data-ajax-ctrl
        >
        Name (A-Z)
        </a>
      </li>
      <li class="filter-group__item" data-href="?sort_by=title-descending">
        <a
          data-href="?sort_by=title-descending"
          data-value="&amp;sort.title=desc"
          data-filter-sort
          data-ajax-ctrl
        >
        Name (Z-A)
        </a>
      </li>
    `;
  }

  _onSubmit = (evt) => {
    evt.preventDefault();
  }

  _handleScrollEnd = (evt) => {
    evt.preventDefault();

    if (this.resultsGrid.scrollHeight - 1400 < window.scrollY) {
      this.pagination?.querySelector('button')?.click();
    }
  }

  _handleScroll = (evt) => {
    evt.stopPropagation()
    const element = this.resultsGrid;

    const scrollPosition = window.scrollY
    const nearBottom = scrollPosition / element.scrollHeight >= 0.7 // within 30% of the bottom

    if (nearBottom && !this.triggered) {
      this.triggered = true
      this.pagination?.querySelector('button')?.click();
    }
  }
}

customElements.define("main-search", MainSearch);
